
export default {
    setColumns({ commit }, columns) {
        commit('setColumns', columns);
    },

    setFixedColumns({ commit }, columns) {
        commit('setFixedColumns', columns);
    },

    setSortedColumns({ commit }, columns) {
        commit('setSortedColumns', columns);
    },

    pushFixedColumn({ commit }, column) {
        commit('pushFixedColumn', column);    
    },

    removeFixedColumn({ commit }, column) {
        commit('removeFixedColumn', column);    
    },

    setBodyRows({ commit }, rows) {
        commit('setBodyRows', rows);
    },

    setHeaderRows({ commit }, rows) {
        commit('setHeaderRows', rows);
    },

    setFooterRows({ commit }, rows) {        
        commit('setFooterRows', rows);
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/table_v3/actions.js